import { useState, useEffect } from 'react';

/**
 * Returns a key that increments on every theme-change event.
 * Use as `key` prop on Chart.js components to force re-render.
 */
export function useThemeKey(): number {
  const [key, setKey] = useState(0);
  useEffect(() => {
    const handler = () => setKey((k) => k + 1);
    window.addEventListener('theme-change', handler);
    return () => window.removeEventListener('theme-change', handler);
  }, []);
  return key;
}
